export enum FileType {
    IMAGE = 0,
    PDF = 1,
    FILE = 2,
    ERROR = 3
  }
